
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "submitSetting",
})
export default class submitSetting extends Vue {
  @Prop({
    required: true,
  })
  private data!: any;
  @Prop({
    default: false,
  })
  private disabled!: boolean;
}
